import i18n from '../../i18n';

/**
 * Ordre des trois dates d'un proces-verbal.
 *
 * L'accident survient, l'entite de constat dresse le PV, le bureau le recoit.
 * Le formulaire ne validait jusqu'ici que les deux extremites de cette chaine ;
 * la date d'etablissement s'y insere au milieu.
 *
 * La date d'etablissement est facultative - un PV ancien, ou dont la date est
 * illisible, doit rester enregistrable. Son absence ne casse pas la chaine, elle
 * la raccourcit : on compare alors directement l'accident et la reception.
 *
 * Les dates sont des chaines ISO comparables lexicographiquement (YYYY-MM-DD) :
 * la regle reste pure et ignore dayjs, c'est l'appelant qui formate.
 *
 * @returns {string|null} le message a afficher, ou null si tout est coherent.
 */
export const erreurChronologie = ({ accident, etablissement, reception } = {}) => {
  if (etablissement && accident && etablissement < accident) {
    return i18n.t('pvSinistres:chronologie.dresseAvantAccident');
  }

  // Le maillon amont de la reception : le PV s'il est date, l'accident sinon.
  const avantReception = etablissement || accident;
  if (reception && avantReception && reception < avantReception) {
    return etablissement
      ? i18n.t('pvSinistres:chronologie.recuAvantDresse')
      : i18n.t('pvSinistres:chronologie.recuAvantAccident');
  }

  return null;
};
